import Flickity from 'flickity-fade';

document.addEventListener('alpine:init', () => {
    Alpine.data('simpleSlider', () => ({
        slider: null,
        sliderContainer: null,
        selectedIndex: 0,
        loading: true,
        progress: 0,
        init() {
            this.sliderContainer = this.$refs.slider;
            const slides = this.sliderContainer.querySelectorAll('.Simple__Slider--slide');
            const initialIndex = this.sliderContainer.dataset?.initialIndex ?? 0;

            this.slider = new Flickity(this.sliderContainer, {
                cellAlign: 'center',
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                draggable: true,
                fade: true,
                initialIndex: initialIndex,
                on: {
                    ready: function() {
                        setTimeout(() => {
                            window.dispatchEvent(new Event('resize'));
                        }, 500);
                    },
                    change: () => {
                        this.selectedIndex = this.slider?.selectedIndex ?? 1;
                        this.progress = ((this.selectedIndex + 1) / slides.length) * 100;
                    }
                }
            });

        },
    }))
});